/**
 * Compact status pill used across the Result page (native / non-native / weed
 * / keystone / endangered / etc.). Small enough that colocating with a bigger
 * component adds noise; large enough that inlining it 6-8 times in Result.jsx
 * bloats the file. Tone-to-color mapping lives here so a design refresh only
 * touches one place.
 */
export const Badge = ({ children, tone = "leaf", testId }) => {
  const tones = {
    leaf: "bg-[#E6EFE9] text-leaf",
    weed: "bg-[#FDF0E7] text-rust",
    beneficial: "bg-[#E9F0D9] text-[#4A5D23]",
    warn: "bg-[#FFF4DC] text-[#8a6a14]",
    mute: "bg-parchment text-leaf-mist",
    danger: "bg-[#FBE3D9] text-rust",
  };
  return (
    <span data-testid={testId} className={`badge-pill ${tones[tone] || tones.leaf}`}>
      {children}
    </span>
  );
};

export default Badge;
